import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { resolvePageSeo } from '../seo/resolve-page-seo';
import { GtmEvent, isGtmEnabled, pushGtmEvent } from '../utils/gtm.util';

export const useGtmPageView = () => {
  const { pathname, search } = useLocation();
  const lastTrackedPath = useRef<null | string>(null);

  useEffect(() => {
    if (!isGtmEnabled()) return;

    const path = `${pathname}${search}`;

    if (lastTrackedPath.current === null) {
      lastTrackedPath.current = path;
      return;
    }

    if (lastTrackedPath.current === path) return;

    lastTrackedPath.current = path;

    pushGtmEvent({
      event: GtmEvent.VIRTUAL_PAGE_VIEW,
      page_location: window.location.href,
      page_path: path,
      page_title: resolvePageSeo(pathname).title,
    });
  }, [pathname, search]);
};
